/**
 * Mando Settings
 */

const settings = {
  arrowNext: `<button class="c-gallery-nav__paging-btn" type="button">
                <svg class="c-gallery-nav__paging-icon" aria-hidden="true" focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#next"></use>
                </svg>
                <span class="visually-hidden">Next slide</span>
              </button>`,
  arrowPrev: `<button class="c-gallery-nav__paging-btn" type="button">
                <svg class="c-gallery-nav__paging-icon" aria-hidden="true" focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#prev"></use>
                </svg>
                <span class="visually-hidden">Previous slide</span>
              </button>`,

  slickPlay: {
    action: 'slickPause',
    newClass: 'c-hero__playback-button--pause',
    oldClass: 'c-hero__playback-button--play',
    text: 'Pause slides',
  },
  slickPause: {
    action: 'slickPlay',
    newClass: 'c-hero__playback-button--play',
    oldClass: 'c-hero__playback-button--pause',
    text: 'Play slides',
  },
};

export default settings;




// WEBPACK FOOTER //
// ./src/scripts/settings.js